/** Build-time city switches (REACT_APP_CITY_KEY). */
export const showSheTheyForwardFilter =
  process.env.REACT_APP_CITY_KEY !== 'mmw';
